import React from 'react';
import { makeStyles } from 'tss-react/mui';

import Button from '@mui/material/Button';
import Zoom from '@mui/material/Zoom';
import simplifiLogoLight from 'assets/logos/simplifi-logo-text-dark.svg';
import { NavLink } from 'react-router-dom';

const useStyles = makeStyles()((_theme) => ({
  logoText: {
    height: 40,
    marginRight: 24,
  },
  logoButton: {
    padding: 8,
    minWidth: 0,
  },
}));

const LogoText = (props) => {
  const { classes } = useStyles();
  return (
    <Zoom in style={{ transitionDelay: '100ms' }}>
      <div>
        <Button id='logo-nav' component={NavLink} to='/' className={classes.logoButton} {...props}>
          <img src={simplifiLogoLight} className={classes.logoText} alt='Quicken Simplifi, click to go Dashboard' />
        </Button>
      </div>
    </Zoom>
  );
};

export default LogoText;
